import React from 'react';
import { Rect, Layer } from 'react-konva';

const ImageRects = ({
  lines, scale, cleanLine, handleMouseDown, handleMouseMove, handleMouseUp,
}) => {
  const renderedRects = lines.map((line) => (
      <Rect
        key={line.id}
        x = {line.x1}
        y = {line.y1}
        width={line.x2 - line.x1}
        height={line.y2 - line.y1}
        stroke={line.color}
        onClick={ () => {
          cleanLine(line.id);
        }}
        onMouseDown={(e) => {
          handleMouseDown(e);
        }}
        onMouseMove={(e) => {
          handleMouseMove(e);
        }}
        onMouseUp={() => {
          handleMouseUp();
        }}
        fill={line.color}
        opacity={0.4}
        />
  ));
  return (
    <Layer
      x={2 - (2 * (scale || 1))}
      y={2 - (2 * (scale || 1))}
      scale={{ x: scale || 1, y: scale || 1 }}
    >
      {renderedRects}
    </Layer>
  );
};

export default ImageRects;
